<template>
    <a class="nav-link" title="Messenger" href="#">
        <slot/>
        <span v-if="messagesCount>0" class="badge badge-primary">{{messagesCount}}</span>
    </a>
</template>

<script>
  export default {
    name: '',
    data() {
      return {
      }
    },
    computed: {
      messagesCount(){
        return this.$store.getters['user/unreadMessages']
      }
    }
  }
</script>

<style lang="sass" scoped>
    @import '../../assets/sass/vars.scss'
    .badge
        background-color: $colorPrimary
        color: #FFF
        font-size: .8em
        border-radius: 50%
        padding: .2em .6em
        display: inline-block


</style>



// WEBPACK FOOTER //
// src/components/messenger/CountBadge.vue